<button
  kendoButton
  [type]="type"
  [disabled]="disabled"
  class="primary-button"
  (click)="onClick($event)"
>
  @if (icon && iconPosition === 'left') {
    <kendo-svg-icon [icon]="icon" class="primary-button__icon"></kendo-svg-icon>
  }
  <ng-content></ng-content>
  @if (icon && iconPosition === 'right') {
    <kendo-svg-icon [icon]="icon" class="primary-button__icon"></kendo-svg-icon>
  }
</button>
